import _ from 'lodash';
import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { Modal, Spin, Card, Switch, Icon,notification} from 'antd';
import MissionStatement from 'components/goals/steps/MissionStatement';
import GoalSettingModal from 'components/goals/GoalSettingModal';
import Titlebar from 'components/layouts/Titlebar';
import Goal from 'core/Goal';
import { translate  } from 'react-i18next';
const { Meta } = Card;

class GoalList extends Component {
    constructor(props) {
        super(props);
        this.crudService = props.crudService;
        this.googleService=props.googleService;

        this.state = { goals: [], goalId: props.goalId, loading: true }
    }

    async componentWillReceiveProps(nextProps) {
        if (nextProps.goalId !== _.get(this.state, 'currentGoal.id')) {
            this.setState({ loading: true });
            const goals = await this.reloadGoals(nextProps.user.id);
            const currentGoal = this.getDefaultGoal(goals, nextProps.goalId);
            this.setState({ goals, currentGoal, loading: false });
        }
    }

    async componentWillMount() {
        this.setState({ loading: true });
        const goals = await this.reloadGoals(this.props.user.id);
        const currentGoal = this.getDefaultGoal(goals, this.props.goalId);
        this.setState({ goals, currentGoal, loading: false });
    }

    async saveGoal(goal) {
        if (goal) {
            this.setState({ loading: true });
            const goals = await this.reloadGoals(this.props.user.id);
            const currentGoal = this.getDefaultGoal(goals, goal.id);
            this.setState({ goals, currentGoal, loading: false });
            this.onUpdate(goal);
        }
    }

    getDefaultGoal(goals, goalId) {
        const defaultGoal = _.find(goals, (goal) => goalId === goal.id);
        if (defaultGoal) {
            defaultGoal.enabled = true;
        }
        return defaultGoal;
    }

    async onSwitchChange(e, goal) {
        if (e === true && await this.onUpdate(goal)) {
            this.state.goals.map((g) => g.enabled = false);
            goal.enabled = true;
            this.setState({ goals: this.state.goals, currentGoal: goal });
        }
    }

    async onDelete(e, goal) {
        this.setState({ loading: true });
     
        const isSuccessfull = await this.crudService.deletegoalIds(this.props.user.id,goal);
                if (isSuccessfull) {
                  notification.open({ message: 'Goal Record deleted successfully.' });
                  this.setState({ loading: true });
                    const goals = await this.reloadGoals(this.props.user.id);
                    const currentGoal = this.getDefaultGoal(goals, this.props.goalId);
                    this.setState({ goals, currentGoal, loading: false });
                } else {
                    notification.open({ message: 'Goal Not Deleted' });
                    this.setState({ loading: false });
                }
    }

    async reloadGoals(userId) {
        this.setState({ loading: true });
        const goals = await this.props.crudService.listByUserId(userId);
        this.setState({ goals: goals, loading: false });
        return goals;
    }

    async onUpdate(goal) {
        const isSuccess = true;
        if (this.props.onUpdate) {
            return await this.props.onUpdate(goal);
        }

        return isSuccess;
    }

    openModal(goal) {
        this.refs.goalSettingModal.showModal(goal);
    }

    createGoal() {
        const goal = new Goal(null, this.props.user.id);
        this.openModal(goal);
    }

    render() {
        return (
            <Spin spinning={this.state.loading}>
                <Titlebar title={this.props.t('goal.title')} description={this.props.t('goal.description')}/>
                <Row center="md">
                    {this.state.goals.map(goal => this.renderGoal(goal))}
                    {this.renderAddGoal()}
                </Row>
                <GoalSettingModal translate={this.props.t} googleService={this.googleService} goal={this.state.currentGoal} user={this.props.user} ref="goalSettingModal" onUpdate={(goal) => this.saveGoal(goal)}  onRevert={(goal) => this.revertGoal(goal)}/>
            </Spin>
        );
    }

    renderAddGoal() {
        return (
            <Col md={3}>
                <Card onClick={() => this.createGoal(this.props.user.id)} className="add-goal">{this.props.t('goal.addNewGoal')}</Card>
            </Col>
        );
    }

    renderGoal(goal) {
        return (
            <Col md={3} key={goal.id}>
              <Card
                className="goal-card"
                hoverable
                cover={<img src={`https://placeimg.com/300/200/arch?random=${goal.id}`} width="100%" onClick={() => this.openModal(goal)}/>}
                actions={[<Icon type="setting" onClick={() => this.openModal(goal)}/>,<Switch checked={goal.enabled} onChange={(e) => this.onSwitchChange(e, goal)}/>,<div onClick={(e) => this.onDelete(e, goal)}><Icon type="delete" title="Delete" /> Delete</div>]}
              >
                <Meta
                  onClick={() => this.openModal(goal)}
                  title={goal.statement}
                />
              </Card>
            </Col>
        );
    }
}

export default translate('translations')(GoalList);


// WEBPACK FOOTER //
// ./src/components/goals/GoalList.js